import StateTimeTracker from '@Services/StateTimeTracker';
import store from '@Store';
import get from 'lodash/get';
import { getCombinedRouteParams, getTrackingPathName } from '@AppRoutes/AppRoutesSelectors';
import history from '@AppRoutes/history';
import Catalyst from '@Services/Catalyst';
import NewRelicService from '@Services/NewRelicService';
import NavigationHistory from '@Services/NavigationHistory';
import PageData from '@Services/PageData';
import { reloadOTSettingsButton } from '@Services/OneTrustCookies';
import { dispatchSetStateCurrent } from '@Actions/StateCurrentActions';
import { interactionSubscriptionVars } from '@AppRoutes/constants';

export function trackOnRouteChangeStart() {
  const combinedParams = getCombinedRouteParams(store.getState());
  const trackingPathName = getTrackingPathName(store.getState());
  if (trackingPathName) StateTimeTracker.start(trackingPathName, combinedParams);

  NavigationHistory.addState(trackingPathName, combinedParams);

  if (interactionSubscriptionVars.subscription) {
    const shouldCancelInteraction =
      get(interactionSubscriptionVars, 'interaction.shouldCancelInteraction', undefined) &&
      interactionSubscriptionVars.interaction.shouldCancelInteraction(
        { name: trackingPathName },
        { ...combinedParams },
        interactionSubscriptionVars.interaction.params
      );
    if (shouldCancelInteraction && interactionSubscriptionVars.cancelBrowserInteraction) {
      interactionSubscriptionVars.cancelBrowserInteraction();
    }
  }
}

export const handleSkipLinkFocus = () => {
  if (document.activeElement?.getAttribute('role') === 'tab') {
    return;
  }

  const navElement = document.getElementById('skip-link-wrap');
  if (navElement) {
    navElement.focus();
  }
};

export function trackOnRouteChangeSuccess() {
  const { location } = history;
  const combinedParams = getCombinedRouteParams(store.getState());
  const trackingPathName = getTrackingPathName(store.getState());
  const { pathname } = location;
  const trackAACustom = get(combinedParams, 'trackAACustom', false);
  const config = {
    trackAACustom,
  };
  Catalyst.trackPage(trackingPathName, combinedParams, config);
  NewRelicService.trackRouteChanges(pathname);

  if (window.usabilla_live) {
    window.usabilla_live('virtualPageView');
  }

  if (get(window, 'adobe.target', false) && !trackAACustom) {
    window.adobe.target.triggerView(PageData.getCurrentPageName());
  }

  dispatchSetStateCurrent(combinedParams);
  reloadOTSettingsButton();
  handleSkipLinkFocus();
}
